import { merge } from '@package/utils/src/merge';
import dynamic from 'next/dynamic';
import { NextSeoProps, DefaultSeoProps as NextDefaultSeoProps } from 'next-seo/lib/types';

const NextSeo = dynamic<NextSeoProps>(() => import('next-seo').then((mod) => mod.NextSeo));
const NextDefaultSeo = dynamic<NextDefaultSeoProps>(() => import('next-seo').then((mod) => mod.DefaultSeo));

type SeoProps = NextSeoProps;
type DefaultSeoProps = NextDefaultSeoProps;

export const Seo = (props: SeoProps) => {
  return <NextSeo {...props} />;
};

export const viewportScale = {
  additionalMetaTags: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    },
  ],
};

const defaultProps = {
  additionalMetaTags: [
    {
      name: 'viewport',
      content: 'minimum-scale=1, initial-scale=1, width=device-width',
    },
  ],
};

export const DefaultSeo = (props: DefaultSeoProps) => {
  const seoProps = merge({}, defaultProps, props);

  return <NextDefaultSeo {...seoProps} />;
};
